export default "__VITE_ASSET__BBb$dDoJ__"